/* Shared Pozca storefront tools. No writes to cart, customers or customizer. */
(function () {
  'use strict';
  if (window.__pozcaStorefrontReady) return;
  window.__pozcaStorefrontReady = true;
  var RECENT_KEY = 'pozca:recent-products:v1';
  var handlePattern = /^[\p{L}\p{N}][\p{L}\p{N}\p{M}-]{0,199}$/u;
  var lastTrigger = new WeakMap();
  var recentSequence = 0;
  function readList(key) {
    try { var value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value : []; }
    catch (err) { return []; }
  }
  function saveList(key, value) { localStorage.setItem(key, JSON.stringify(value)); }
  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function openDialog(id, trigger) {
    var dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.open) return true;
    document.querySelectorAll('.pozca-dialog[open]').forEach(function (other) { other.close(); });
    lastTrigger.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    return true;
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pozca-dialog]');
    if (trigger) { if (openDialog(trigger.dataset.pozcaDialog, trigger)) event.preventDefault(); return; }
    var close = event.target.closest('[data-pozca-close]');
    if (close) { var dialog = close.closest('dialog'); if (dialog) dialog.close(); }
  });
  document.querySelectorAll('.pozca-dialog').forEach(function (dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', function () {
      var trigger = lastTrigger.get(dialog);
      if (trigger && document.contains(trigger)) trigger.focus({preventScroll:true});
    });
  });
  // Calculate in store time, counting Monday–Saturday and skipping Sunday as requested.
  function shippingDates(now) {
    var parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Istanbul',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    var value = {}; parts.forEach(function (part) { value[part.type] = part.value; });
    var cursor = new Date(Date.UTC(Number(value.year), Number(value.month)-1, Number(value.day), 12));
    var days = [];
    while (days.length < 3) { cursor.setUTCDate(cursor.getUTCDate()+1); if (cursor.getUTCDay() !== 0) days.push(new Date(cursor)); }
    return [days[0], days[2]];
  }
  function updateDispatch() {
    var range = shippingDates(new Date());
    var formatter = new Intl.DateTimeFormat('tr-TR', {day:'numeric',month:'long',timeZone:'UTC'});
    var label = formatter.format(range[0]) + ' – ' + formatter.format(range[1]);
    document.querySelectorAll('[data-pozca-dispatch]').forEach(function (node) {
      node.textContent = 'Şimdi sipariş verirseniz tahmini kargoya teslim: ' + label + ' (Atölyemizde özenle hazırlanır)';
      node.title = 'Pazar günleri hariç hesaplanır. Resmî tatiller ve atölye yoğunluğu süreyi etkileyebilir.';
    });

  }
  async function renderRecent() {
    var section = document.querySelector('[data-pozca-recent]');
    if (!section) return;
    var ticket = ++recentSequence;
    var target = section.querySelector('[data-pozca-recent-cards]');
    var currentNode = section.querySelector('[data-pozca-current-product]');
    var current = currentNode && currentNode.dataset.pozcaCurrentProduct;
    var history = readList(RECENT_KEY).filter(function (handle) { return typeof handle === 'string' && handlePattern.test(handle) && handle !== 'ani-kutusu'; });
    history = Array.from(new Set(history));
    if (current && handlePattern.test(current) && current !== 'ani-kutusu') {
      history = [current].concat(history.filter(function (handle) { return handle !== current; })).slice(0,5);
      try { saveList(RECENT_KEY, history); } catch (err) { /* Browsing remains usable without storage. */ }
    }
    var handles = history.filter(function (handle) { return handle !== current; }).slice(0,4);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var results = await Promise.all(handles.map(async function (handle) {
      try { var response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'}); if (!response.ok) return null; var product = await response.json(); return product.handle === handle && Number.isFinite(product.price_min) ? product : null; }
      catch (err) { return null; }
    }));
    if (ticket !== recentSequence) return;
    target.replaceChildren();
    results.filter(Boolean).forEach(function (product) {
      var url = root + 'products/' + encodeURIComponent(product.handle);
      var card = make('article', 'iz-pcard'), link = make('a', 'iz-pcard__thumb'); link.href = url; link.setAttribute('aria-label', product.title);
      var imageUrl = product.featured_image;
      if (typeof imageUrl === 'string' && /^(https?:)?\/\//.test(imageUrl)) {
        var image = make('img', 'iz-pcard__img');
        var parsed = new URL(imageUrl, window.location.origin); parsed.searchParams.set('width','500');
        image.src = parsed.href; image.alt = product.title; image.loading = 'lazy'; image.decoding = 'async'; image.width = 500; image.height = 625; link.appendChild(image);
      }
      card.appendChild(link);
      var body = make('div','iz-pcard__body'); body.appendChild(make('h3','iz-pcard__name',product.title));
      var price = new Intl.NumberFormat('tr-TR', {style:'currency',currency:section.dataset.currency || 'TRY'}).format(product.price_min/100);
      body.appendChild(make('div','iz-pcard__footer',(product.price_varies ? 'Başlangıç: ' : '') + price));
      var cta = make('a','iz-pcard__btn','İncele →'); cta.href = url; body.appendChild(cta); card.appendChild(body); target.appendChild(card);
    });
    section.dataset.count = String(target.children.length);
    section.hidden = !target.children.length;
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-pozca-clear-recent]')) return;
    recentSequence++;
    try { localStorage.removeItem(RECENT_KEY); } catch (err) { /* Still clear the current view. */ }
    document.querySelectorAll('[data-pozca-recent]').forEach(function (section) { section.hidden = true; section.dataset.count = '0'; section.querySelector('[data-pozca-recent-cards]').replaceChildren(); });
  });
  function initAnnouncements() {
    document.querySelectorAll('slideshow-component.announcement-bar').forEach(function (slider) {
      var button = slider.querySelector('[data-pozca-announcement-pause]');
      if (!button || button.dataset.ready) return;
      if (!slider.querySelector('[data-autoplay="true"]')) { button.hidden = true; return; }
      button.dataset.ready = 'true';
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var manuallyPaused = false;
      function sync() {
        var paused = manuallyPaused || motion.matches || document.hidden;
        slider.announcementBarArrowButtonWasClicked = paused;
        if (typeof slider.pause === 'function') {
          if (paused) slider.pause();
          else slider.play();
        }
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? 'Devam et' : 'Duraklat';
        button.disabled = motion.matches;
      }
      button.addEventListener('click', function () { manuallyPaused = !manuallyPaused; sync(); });
      motion.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      sync();
    });
  }
  initAnnouncements();
  document.addEventListener('shopify:section:load', initAnnouncements);
  updateDispatch(); renderRecent();
  document.addEventListener('shopify:section:load', updateDispatch);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) updateDispatch(); });
  window.addEventListener('pageshow', updateDispatch);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, updateDispatch);
})();
